import Swiper, { Navigation }  from 'swiper';

const SubsectionNavigation = ($, context) => {

  const $expand = $("section.subsection-nav .expand", context)
  const $list = $("section.subsection-nav .subsection-nav__wrap ul", context)
  const $target = $('section.subsection-nav .swiper', context)
  const swiperTarget = $target ? $target[0] : null
  let $swiper, currentBP
  let currentWindowWidth = 0

  const onResize = (e) => {
    const w = $( window ).width()

    /* Only fire if window width actually changed */
    if(currentWindowWidth == window.innerWidth)
      return;
    currentWindowWidth = window.innerWidth

    $expand.removeClass('expand--expanded')
    $list.removeAttr("style")
    if(w >= 1024 && currentBP != 'desktop') {
      currentBP = 'desktop'
      initializeDesktop()
    }
    else if(w < 1024 && currentBP != 'mobile') {
      currentBP = 'mobile'
      initializeMobile()
    }
  }

  const mobileToggle = (e) => {
    e.preventDefault()
    $expand.toggleClass('expand--expanded')
    $list.slideToggle()
  }

  const initializeMobile = () => {
    $swiper?.destroy()
    $swiper = null
    $list.hide(0);
    $expand.removeClass('expand--expanded')
    $expand.on('click', mobileToggle)
  }

  const initializeDesktop = () => {
    $expand.removeClass('expand--expanded')
    $expand.off('click', mobileToggle)
    $list.show(0);

    /* Init carousel */
    $swiper = new Swiper(swiperTarget, {
      modules: [Navigation],
      slidesPerView: "auto",
      freeMode: true,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
      },
    })
  }

  var self = {
    init: () => {
      if($("section.subsection-nav", context).length == 0) {
        return
      }
      // $( window ).resize(onResize)
      window.addEventListener("resize", onResize);
      onResize()
    }
  }

  return self;
}

export default SubsectionNavigation